import type { LayoutBlock } from '@web-studio/shared-schemas';
import { pickChrome } from '../lib/siteChromeCopy';
import { escapeHtml } from './escape';

export function resolveLeadFormKey(block: LayoutBlock, fallback: string): string {
  return block.dataBinding?.kind === 'form' ? block.dataBinding.formKey : fallback;
}

/** Opening tag for Path A lead forms — pairs with `/api/site-assets/site-lead-forms.js`. */
export function renderLeadFormOpenTag(options: {
  className: string;
  formKey: string;
  locale: string;
  successChromeKey?: 'reservationStatusSuccess' | 'formStatusSuccess';
}): string {
  const successKey = options.successChromeKey ?? 'formStatusSuccess';
  return `<form class="${options.className}" action="#" method="post" data-ws-lead-form data-form-key="${escapeHtml(options.formKey)}" data-locale="${escapeHtml(options.locale)}" data-status-sending="${escapeHtml(pickChrome('formStatusSending', options.locale))}" data-status-success="${escapeHtml(pickChrome(successKey, options.locale))}" data-status-error="${escapeHtml(pickChrome('formStatusError', options.locale))}">`;
}

export function renderFormInput(
  field: { name: string; type: string; required: boolean; label: string },
  fieldClass = 'ws-form__field',
  locale = 'de',
): string {
  const requiredAttr = field.required ? ' required' : '';
  const label = escapeHtml(field.label);
  const name = escapeHtml(field.name);
  const wide =
    field.type === 'textarea' || field.name === 'message' || field.name === 'allergens';
  const className = [fieldClass, wide ? 'ws-form__field--wide' : ''].filter(Boolean).join(' ');
  const requiredMark = field.required
    ? `<abbr class="ws-form__required" title="${escapeHtml(pickChrome('requiredMark', locale))}">*</abbr>`
    : '';
  const labelSpan = `<span>${label}${requiredMark}</span>`;

  if (field.type === 'textarea') {
    return `<label class="${className}">${labelSpan}<textarea name="${name}" rows="4"${requiredAttr}></textarea></label>`;
  }

  const inputType = field.type === 'tel' ? 'tel' : field.type;
  const autocomplete =
    field.name === 'email'
      ? ' autocomplete="email"'
      : field.name === 'name'
        ? ' autocomplete="name"'
        : field.name === 'phone'
          ? ' autocomplete="tel"'
          : '';

  let extra = '';
  if (field.type === 'number' && field.name === 'guests') {
    extra = ' min="1" max="20" value="2"';
  }

  return `<label class="${className}">${labelSpan}<input type="${escapeHtml(inputType)}" name="${name}"${autocomplete}${extra}${requiredAttr} /></label>`;
}
